import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import Content from '@components/pages/SubscribeTest/Variants/T/Content';
import { AppContextProvider } from '@contexts/AppContext';
import { SubscribeFormProvider } from '@contexts/SubscribeFormContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';

import type { SubscribeTestTProps } from './interfaces';

const queryClient = new QueryClient();

const SubscribeTestT = (props: SubscribeTestTProps) => {
  const { Track } = useEventTracking({
    page: Page.SubscribeTestT,
  });

  const {
    isYPEligible,
    stripeCustomerId,
    subscriptionStatus,
    userDobVerified,
    userEmail,
    userFullName,
    userId,
  } = props;

  return (
    <AppContextProvider
      initialCurrentUser={props.initialCurrentUser}
      isGdprRequired={props.isGdprRequired}
    >
      <SubscribeFormProvider
        user={{
          dobVerified: userDobVerified,
          email: userEmail,
          id: userId,
          isYPEligible,
          name: userFullName,
          stripeCustomerId,
          subscriptionStatus,
        }}
      >
        <QueryClientProvider client={queryClient}>
          <Track>
            <Content {...props} />
          </Track>
        </QueryClientProvider>
      </SubscribeFormProvider>
    </AppContextProvider>
  );
};

export default SubscribeTestT;
